import {ChangeDetectionStrategy, Component, DestroyRef, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NavigationEnd, NavigationStart, Router, Event as RouterEvent} from '@angular/router';
import {NzLayoutComponent, NzContentComponent, NzHeaderComponent} from 'ng-zorro-antd/layout';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {NzWaveDirective} from 'ng-zorro-antd/core/wave';
import {ɵNzTransitionPatchDirective} from 'ng-zorro-antd/core/transition-patch';
import {NzSpinComponent} from 'ng-zorro-antd/spin';

/**
 * Landing component as the initial page of the project which contains a button that allows the user to go to the file upload page where Excel files can be uploaded.
 */
@Component({
    selector: 'PIDB-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NzLayoutComponent,
        NzContentComponent,
        NzHeaderComponent,
        NzButtonComponent,
        NzWaveDirective,
        ɵNzTransitionPatchDirective,
        NzSpinComponent,
    ],
})
export class LandingComponent {
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    //Loader variable default true before page load
    loader = signal(false);
    constructor() {
        this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e: RouterEvent) => {
            this.navigationInterceptor(e);
        });
    }

    /**
     * Navigate to file upload page whenever get started button is clicked.
     */
    getStarted() {
        this.router.navigate(['/home/file-upload']);
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.loader.set(true);
        }
        if (event instanceof NavigationEnd) {
            setTimeout(() => {
                this.loader.set(false);
            }, 2000);
        }
    }
}
